// HubSpot custom behavioural events sent from the browser (DEV-6904). Each one
// has to exist in HubSpot (Data Management > Custom Events) with this internal
// name, and each property has to be created on the event, or HubSpot drops it.
// The backend events (downloads, boards, payments) are sent by the APIs instead.
export const HUBSPOT_EVENTS = {
  usedSearch: 'pe147880604_used_search',
  usedClaimReleaseTool: 'pe147880604_used_claim_release_tool',
  usedPlaylistGenerator: 'pe147880604_used_playlist_generator',
  usedSyncPreview: 'pe147880604_used_sync_preview',
  usedCustomizeDuration: 'pe147880604_used_customize_duration',
  usedChatbot: 'pe147880604_used_chatbot',
  toggledFreeOnly: 'pe147880604_toggled_free_only',
  uploadedFile: 'pe147880604_uploaded_a_file',
} as const;

export type HubSpotEventName =
  (typeof HUBSPOT_EVENTS)[keyof typeof HUBSPOT_EVENTS];

export const addHubSpotEvent = (
  name: HubSpotEventName,
  properties?: Record<string, string | number | undefined>
) => {
  // There's one live HubSpot account, so only production sends events
  if (process.env.NEXT_PUBLIC_ENV !== 'production') {
    return;
  }

  try {
    if (typeof window === 'undefined') {
      return;
    }

    // HubSpot attaches the event to the contact identified in useSettings
    window._hsq = window._hsq || [];
    window._hsq.push(['trackCustomBehavioralEvent', { name, properties }]);
  } catch {
    // Event tracking failed, but don't break the app
  }
};
